module.exports = __webpack_public_path__ + "static/media/dyn3.7e42532e.png";